import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'SFDate' })
export class SFFormatDatePipe implements PipeTransform {
    transform(content: any, type?: any): any {

        if (content && moment(content).isValid()) {
            try {
                // Date Now
                let dateNow = moment();
                // Date From DB
                let mindiff = new Date().getTimezoneOffset();
                let newContent = moment(content).add(mindiff, 'minutes').toISOString();
                let result;
                switch (type) {
                    case 'timeattendance':
                        result = moment(content).format('HH:mm:ss');
                        break;
                    case 'yyyy-MM-dd':
                        result = moment(newContent).format('YYYY-MM-D');
                        break;
                    case 'dddDMMM':
                        result = moment(newContent).format('ddd, D MMM');
                        break;
                    case 'MMMDYYYY':
                        result = moment(newContent).format('MMM, D YYYY');
                        break;
                    case 'HHMM':
                        result = moment(newContent).format('HH:mm');
                        break;
                    case 'HHMMs':
                        result = moment(content).format('HH:mm');
                        break;
                    case 'HH:mm':
                        result = moment(newContent).format('HH:mm');
                        break;
                    case 'HH:mm:ss':
                        result = moment(newContent).format('HH:mm:ss');
                        break;
                    case 'DMMMYYYY':
                        result = moment(newContent).format('D MMM YYYY');
                        break;
                    case 'ROOMCHAT':
                        let hours = dateNow.diff(moment(newContent), 'hours');
                        if (hours < 24) {
                            result = moment(newContent).fromNow();
                        } else {
                            result = moment(newContent).format('MMM, D YYYY HH:mm');
                        }
                        break;
                    case 'LISTCHAT':
                        let chathours = dateNow.diff(moment(content), 'hours');
                        if (chathours < 24) {
                            result = moment(content).fromNow();
                        } else {
                            result = moment(content).format('MM/DD/YY');
                        }
                        break;
                    case 'DAYGROUP':
                        result = moment(content).calendar(null, {
                            sameDay: '[Today]',
                            nextDay: '[Tomorrow]',
                            nextWeek: 'dddd',
                            lastDay: '[Yesterday]',
                            lastWeek: '[Last] dddd',
                            sameElse: 'DD/MM/YYYY'
                        });
                        break;
                    case 'LISTFEED':
                        let listfeed = dateNow.diff(moment(content), 'hours');
                        if (listfeed < 24) {
                            result = moment(content).fromNow();
                        } else {
                            result = moment(content).format('D MMM');
                        }
                        break;
                    case 'CalendarDetailDate':
                        result = moment(newContent).format('D MMM YY');
                        break;
                    case 'CalendarDetailTime':
                        result = moment(newContent).format('HH:mm');
                        break;
                    case 'CalendarDetailTimeZone':
                        result = new Date(newContent).toString().match(/\((.*)\)/).pop();
                        break;
                    case 'ddMMM': result = moment(newContent).format('D MMM'); break;
                    case 'ddMMMyyyyHHmm':
                        result = moment(content).format('D MMM YYYY HH:mm ');
                        break;
                    case 'ddMMMyyyyHHmmNew':
                        result = moment(newContent).format('D MMM YYYY HH:mm');
                        break;
                    case 'ddMMMyyyyHHmmssNew': {
                        result = moment(newContent).format('D MMM YYYY HH:mm:ss');
                        break;
                    }
                    case 'ddMMMyyyy':
                        result = moment(newContent).format('D MMM YYYY');
                        break;
                    case 'ddMMMyyyy':
                        result = moment(newContent).format('D MMM YYYY');
                        break;
                    case 'ddMMMMyyyyClaim':
                        result = moment(dateNow).format('DD MMMM YYYY');
                        break;
                    case 'ddMMMyyyysf6':
                        result = moment(content).format('D MMM YYYY');
                        break;
                    case 'ddMMMMyyyysf6':
                        result = moment(content).format('D MMMM YYYY');
                        break;
                    case 'ddMMMMsf6':
                        result = moment(content).format('D MMMM');
                        break;
                    case 'dddDsf6':
                        result = moment(content).format('ddd, D MMM');
                        break;
                    case 'ddMMMyy':
                        result = moment(newContent).format('D MMM YY');
                        break;
                    case 'MMMDYYYYMoment':
                        result = moment(content).format('MMM, D YYYY');
                        break;
                    case 'HHMMMoment':
                        result = moment(content).format('HH:mm');
                        break;
                    case 'LISTDATE':
                        let hari = moment(dateNow).startOf('day').diff(moment(newContent).startOf('day'), 'days');
                        let tahun = dateNow.diff(moment(newContent), 'years');
                        if (hari == 0) {
                            let timeOffset = new Date().getTimezoneOffset();
                            let timeOffset2 = timeOffset + 420;
                            let context = moment(newContent).add(-(timeOffset2), 'minutes').toISOString();
                            result = moment(context).format('HH:mm');
                        } else if (tahun == 0) {
                            result = moment(newContent).format('D MMM');
                        } else {
                            result = moment(newContent).format('D MMM YYYY');
                        }
                        break;
                    case 'LISTDATEGDBClaim':
                        let hariClm = moment(dateNow).startOf('day').diff(moment(newContent).startOf('day'), 'days');
                        let tahunClm = dateNow.diff(moment(newContent), 'years');
                        if (hariClm == 0) {
                            console.log('masuk if claim');
                            let timeOffset = new Date().getTimezoneOffset();
                            let timeOffset2 = timeOffset + 420;
                            let context = moment(newContent).add(-(timeOffset2), 'minutes').toISOString();
                            result = moment(context).format('HH:mm');
                        } else if (tahunClm == 0) {
                            console.log('masuk else if claim');
                            result = moment(newContent).format('D MMM');
                        } else {
                            console.log('masuk else claim');
                            result = moment(newContent).format('D MMM YYYY');
                        }
                        break;
                    case 'LISTDATE2':
                        let hari3 = moment(dateNow).startOf('day').diff(moment(newContent).startOf('day'), 'days');
                        let tahun3 = dateNow.diff(moment(newContent), 'years');
                        if (hari3 == 0) {
                            let timeOffset = new Date().getTimezoneOffset();
                            let timeOffset2 = timeOffset + 420;
                            let context = moment(newContent).add(-(timeOffset2), 'minutes').toISOString();
                            result = moment(context).format('HH:mm');
                        } else if (tahun3 == 0) {
                            result = moment(newContent).format('D MMM');
                        } else {
                            result = moment(newContent).format('D MMM YYYY');
                        }
                        break;
                    case 'LISTDATENEW':
                        let hari2 = moment(dateNow).startOf('day').diff(moment(newContent).startOf('day'), 'days');
                        let tahun2 = dateNow.diff(moment(newContent), 'years');
                        if (hari2 == 0) {
                            result = moment(newContent).format('D MMM');
                        } else if (tahun2 == 0) {
                            result = moment(newContent).format('D MMM');
                        } else {
                            result = moment(newContent).format('D MMM YYYY');
                        }
                        break;
                    case 'LISTDATENEW2':
                        let hari5 = moment(dateNow).startOf('day').diff(moment(content).startOf('day'), 'days');
                        let tahun5 = dateNow.diff(moment(content), 'years');
                        if (hari5 == 0) {
                            result = moment(content).format('D MMM');
                        } else if (tahun5 == 0) {
                            result = moment(content).format('D MMM');
                        } else {
                            result = moment(content).format('D MMM YYYY');
                        }
                        break;
                    case 'MMYYYY':
                        result = moment(newContent).format('MMM YYYY');
                        break;
                    case 'DATEAPPROVAL': /**tolong jangan diubah ke newContent karena dipakai untuk jam sf6 */
                        let hariapp = moment(dateNow).startOf('day').diff(moment(content).startOf('day'), 'days');
                        let tahunapp = dateNow.diff(moment(content), 'years');
                        if (hariapp == 0) {
                            result = moment(content).format('HH:mm');
                        } else if (tahunapp == 0) {
                            result = moment(content).format('D MMM');
                        } else {
                            result = moment(content).format('D MMM YYYY');
                        }
                        break;
                    case 'DDMMYYYY':
                        result = moment(newContent).format('DD/MM/YYYY');
                        break;
                    case 'LISTSOCIAL':
                        let dateSocial = moment(content).add(-420, 'minutes').toISOString();
                        let listsocial = dateNow.diff(moment(dateSocial), 'hours');
                        if (listsocial < 24) {
                            result = moment(dateSocial).fromNow();
                        } else {
                            result = moment(dateSocial).format('D MMM');
                        }
                        break;
                    case 'LISTARCHIVED':
                        result = moment(newContent).format('D MMM, HH:mm');
                        break;
                    case 'TASKFEEDBACKDATE':
                        let taskfeedback = dateNow.diff(moment(newContent), 'hours');
                        if (taskfeedback < 24) {
                            result = moment(newContent).format('HH:mm');
                        } else {
                            result = moment(newContent).format('D MMM');
                        }
                        break;
                    case 'MMMyyyy':
                        result = moment(newContent).format('MMM YYYY');
                        break;
                    case 'H:mm, d/M/y':
                        result = moment(newContent).format('HH:mm, DD/MM/YYYY');
                        break;
                    case 'hhmmsf6':
                        result = moment(content).format('HH:mm');
                        break;
                    case 'HHmmN':
                        content = content.replace("1899", "2013");
                        let timeOffset = new Date().getTimezoneOffset();
                        let context = moment(content).set('year', 2013).add(timeOffset, 'minutes').toISOString();
                        result = moment(context).format('HH:mm');
                        break;
                    case 'DMMMYYYYN':
                        if (typeof content === 'string' || content instanceof String) {
                            result = moment(newContent).format('D MMM YYYY');
                        }
                        else {
                            result = "";
                        }
                        break;
                    case 'HH:mm:chat':
                        result = moment(content).format('HH:mm');
                        break;
                    case 'HOMEFEEDTASK':
                        let dateTask = dateNow.diff(moment(newContent), 'hours');
                        if (dateTask < 24) {
                            result = moment(newContent).fromNow();
                        } else {
                            result = moment(newContent).format('D MMM YYYY');
                        }
                        break;
                    case 'HOMEFEEDTASKHHmm':
                        result = moment(content).utc().format('HH:mm')
                        break;
                    case 'ThermalDate':
                        result = moment(content).format('D MMM YYYY');
                        break;
                    case 'ThermalDateTime':
                        result = moment(content).format('MMM, D YYYY HH:mm');
                        break;
                    case 'ThermalDateTimeUtc':
                        result = moment(content).utcOffset(0, false).format('MMM, D YYYY HH:mm');
                        break;
                    case 'TaskDiscussion':
                        // disable utc, handled from backend
                        result = moment(content).utcOffset(0, false).format('MMM, D YYYY HH:mm');
                        break;
                    case 'NEWDATEAPPROVAL':
                        let hariapp2 = moment(dateNow).startOf('day').diff(moment(newContent).startOf('day'), 'days');
                        let tahunapp2 = dateNow.diff(moment(newContent), 'years');
                        if (hariapp2 == 0) {
                            result = moment(newContent).format('HH:mm');
                        } else if (tahunapp2 == 0) {
                            result = moment(newContent).format('D MMM');
                        } else {
                            result = moment(newContent).format('D MMM YYYY');
                        }
                        break;
                    default:
                        result = moment(newContent).format('MMM, D YYYY HH:mm');
                }
                return result;
            } catch (error) {
                return "";
            }
        } else {
            return '';
        }

    }
}



// WEBPACK FOOTER //
// ./src/pipes/SFFormatDate.ts